<template>
    <div class="fl_flex">
        <div class="quick_left">
            <!--  跟进 -->
            <AddRecord :id="id"  @reloadData="loadData" @beforeOne="beforeOne" @nextOne="nextOne" ref="AddRecord"></AddRecord>
            <!--  分配记录 -->
            <div class="white_bg" v-if="distributionLogList.length > 0">
                <div style="color: #A39A96; width: 70px; ">分配记录：</div>
                <div v-for="(log, index) in distributionLogList" :key="index">
                    <span class="icon iconfont icon-biaoji_" style="font-size: 10px; margin: 0 10px;"></span>
                    <span>{{log.created_at}} {{log.content}}</span>
                </div>
            </div>
            <!--  上门记录 -->
            <div class="white_bg" v-if="viewLogList.length > 0">
                <div style="color: #A39A96; width: 70px; ">上门记录：</div>
                <div v-for="(log, index) in viewLogList">
                    <span class="icon iconfont icon-biaoji_" style="font-size: 10px; margin: 0 10px;"></span>
                    <span>{{log.created_at}} {{log.content}}</span>
                </div>
            </div>
            <!--  送件记录 -->
            <div class="white_bg"  v-if="loanLogList.length > 0">
                <div style="color: #A39A96; width: 70px; ">送件记录：</div>
                <div v-for="(log, index) in loanLogList">
                    <span class="icon iconfont icon-biaoji_" style="font-size: 10px; margin: 0 10px;"></span>
                    <span>{{log.created_at}} {{log.content}}</span>
                </div>
            </div>
            <!--  主管点评 -->
            <div class="white_bg">
                <div style="font-weight: bold; width: 70px; margin-top: 5px;">主管点评：</div>
                <div style="display: flex;margin: 10px 0;">
                    <Input v-model="remarkValue" type="textarea" :rows="2"/>
                    <div @click="saveComment" style="cursor: pointer; color: #FFFFFF; background-color: #21A0FF; width: 60px; display: flex; justify-content: center;align-items: center; ">
                        点评
                    </div>
                </div>
            </div>
        </div>
        <div class="quick_right">
            <!--  客户信息 -->
            <div class="white_bg" style="margin-top: 0">
                <ClientMessage :client="client_message"></ClientMessage>
            </div>
            <!--  客户标签 -->
            <div class="white_bg" v-if="tabsList.length > 0">
                <div >
                    <div style="color: #A39A96; width: 70px; ">客户标签：</div>
                    <div class="clientTag">
                        <Tag v-for="(item,index) in tabsList" :key="index" color="primary" closable
                             @on-close="handleClose(item.type, item.id)"
                             :class="{black_css:item.name == '关机' || item.name == '黑户', violet_css:item.name == '停机', green_css:item.name == '不接' || item.name == '不紧要', yellow_css:item.name == '需回拨', grey_css:item.name == '空号',
							orange_css:item.name == '忙线中', red_css:item.name == '挂断' || item.name == '急用钱', blue_css:item.name == '开口挂' || item.name == '近期要',
							ddd_css:item.name == '潜在需求', eee_css:item.name == '否认申请', fff_css:item.name == '异地申请', ggg_css:item.name == '不需要',
						hhh_css:item.name == '有逾期', iii_css:item.name == '捣乱申请', jjj_css:item.name == '同行',aaa_css:item.name == '无条件',bbb_css:item.name == '查询超',ccc_css:item.name == '白户'}"
                             style="width: 100px; text-align: center; border-radius: 5px; margin: 5px;">
                            {{item.name}}
                        </Tag>
                    </div>
                </div>
            </div>
            <!--  客户介绍 -->
            <div class="white_bg" v-if="client.remark">
                <div style="font-weight: bold; width: 70px;margin-bottom: 10px;">客户介绍：</div>
                <div style="padding-left: 10px">
                    {{client.remark}}
                </div>
            </div>
            <!--  跟进记录 -->
            <div class="white_bg" v-if="followLogList.length > 0">
                <div style="font-weight: bold; width: 70px; margin-bottom: 10px;">跟进记录：</div>
                <div >
                    <div v-if="index < 4" v-for="(item, index) in followLogList" :key="index">
                        <span class="icon iconfont icon-biaoji_" style="font-size: 10px; margin: 0 10px;"></span>
                        <span>{{item.created_at}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.content}}</span>
                    </div>
                    <div v-if="followFoldShow && index >= 4" v-for="(item, index) in followLogList" :key="index">
                        <span class="icon iconfont icon-biaoji_" style="font-size: 10px; margin: 0 10px;"></span>
                        <span>{{item.created_at}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.content}}</span>
                    </div>
                    <div v-if="followLogList.length >= 5 && followFoldShow" style="text-align: center;color: #277dd3; font-weight: bold;"><span
                            style="cursor: pointer;" class="icon iconfont icon-shangla" @click="followFoldShow=!followFoldShow"></span></div>
                    <div v-if="followLogList.length >= 5 && !followFoldShow" style="text-align: center; color: #277dd3; font-weight: bold;"><span
                            style="cursor: pointer;" class="icon iconfont icon-shangla1" @click="followFoldShow=!followFoldShow"></span></div>
                </div>
            </div>
            <!-- 按钮 -->
            <div style="position:absolute; bottom: 4%; right: 180px">
                <Button type="primary" style="width: 170px;" @click="toEdit">快捷编辑客户</Button>
            </div>
        </div>

    </div>
</template>

<script>
    import {saveClient, savePolicy, saveCreditCard, saveDebt, getClient, saveComment, cancelTag} from '@/api/client'
    import {mapActions, mapGetters} from "vuex";
    import AddRecord from "./AddRecord";
    import ClientMessage from "./ClientMessage";
    export default {
        name: "quickEditClue",
        components: {ClientMessage, AddRecord},
        props: ['id'],
        created() {
            this.loadData();
        },
        watch: {
            id() {
                this.loadData();
            }
        },
        computed: {
            ...mapGetters(['userInfo', 'token']),
        },
        data() {
            return {
                followFoldShow: false,
                followLogList: [],
                remarkValue: '',
                viewLogList: [],
                tabsList: [],
                loanLogList: [],
                distributionLogList: [],
                client_message: {
                    profession: '',
                    income: '',
                    income_sum: '',
                    house: '',
                    house_sum: '',
                    car: '',
                    car_sum: '',
                    accumulation_fund: '',
                    accumulation_fund_time: '',
                    social_security: '',
                    commercial_insurance: '',
                    commercial_insurance_date: '',
                    wei_li_dai: '',
                    wei_li_dai_sum: '',
                    credit_card: '',
                    credit_card_sum: '',
                    liabilities: '',
                    liabilities_money: '',
                },
                client: {
                    phone: '',
                    certno: '',
                    loans_money: '',
                    loans_period: '',
                    loans_time: '',
					remark:'',
                    ext_info: {
                        age: '',
                        education: '0',
                        maritalStatus: '0',
                        job_type: '0',
                        houseShow: 1,
                        houseMonthShow: 1,
                        houseAllShow: 1,
                        houseLandShow: 1,
                        monthlySum: '',
                        monthlyPeriod: '',
                        monthly_time: '',
                        monthly_location: [],
                        houseSum: '',
                        houseYears: '',
                        buy_time: '',
                        total_location: [],
                        houseSelfSum: '',
                        houseSelfArea: '',
                        self_buy_time: '',
                        self_total_location: [],
                        carShow: '1',
                        carMonthShow: '1',
                        carAllShow: '1',
                        monthly_car_show: '1',
                        carSum: '',
                        buy_car_time: '',
                        car_location: '',
                        total_car_show: '1',
                        carTotalSum: '',
                        car_id_time: '',
                        total_car_location: '',
                        policyShow: '1',
                        social_security_show: '1',
                        social_security_buy_time: '',
                        social_security_cardinal_number: '',
                        accumulation_fund_show: '1',
                        accumulation_fund_buy_time: '',
                        accumulation_fund_cardinal_number: '',
                        accumulation_fund_self_number: '',
                        income_sum: '',
                        income_type: '0',
                        zhima_credit: '0',
                        weilidaiShow: '1',
                        weilidai_sum: '',
                        credit_card_show: '1',
                        debt_show: '1',
                        city: [],
                        introduce: '',
                        overdue_or: 0,
                        overdue_sum: '',
                        overdue_or_6: '',
                        overdue_or_12: '',
                        overdue_or_24: '',
                        overdue_6_number: '',
                        overdue_6_days: '',
                        overdue_12_number: '',
                        overdue_12_days: '',
                        overdue_24_number: '',
                        overdue_24_days: '',
                        unit_name: '',
                        unit_contacts_name: '',
                        unit_contacts_phone: '',
                        unit_site: '',
                        unit_entry_time: '',
                    },
                    type: 0,
                    name: '',
                    sex: 0,
                    source: '',
                    applied_at: '',
                },
            }
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
            handleClose(type, id) {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, client_id: that.client.id, type:type, tag: id};
                    let res = await cancelTag(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.loadData()
                    }
                }, 500)
            },
            async loadData() {
                let that = this;
                var date = new Date();
                this.nowTime = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
                if (that.id != 0) {
                    let data = {token: that.token, id: that.id};
                    let res = await getClient(that, data);
                    if (res.code == 1) {
                        that.client = res.data.item;
                        that.loanLogList = res.data.loanLogList;
                        that.viewLogList = res.data.viewLogList;
                        that.followLogList = res.data.followLogList;
                        that.distributionLogList = res.data.distributionLogList;
                        that.tabsList = res.data.tabsList;
                        that.client_message = res.data.info;
                    }
                }
                that.$emit('reloadData');
            },
            saveComment() {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, remark: that.remarkValue, client_id: that.id};
                    let res = await saveComment(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.remarkValue = '';
                        that.loadData();
                    }
                }, 500)
            },
            beforeOne() {
                let that = this;
                this.$nextTick(() => {
                    that.$emit('beforeOne');
                })
            },
            nextOne() {
                let that = this;
                this.$nextTick(() => {
                    that.$emit('nextOne');
                })
            },
            toEdit() {
                let that = this;
                this.$nextTick(() => {
                    that.$emit('quickEditClient');
                })
            }
        },
    }
</script>

<style scoped lang="less">
    .black_css {
        color: #FFFFFF;
        background-color: #000000;
    }

    .violet_css {
        color: #FFFFFF;
        background-color: #9801FE;
    }

    .green_css {
        color: #FFFFFF;
        background-color: #8FC31F;
    }

    .grey_css {
        color: #FFFFFF;
        background-color: #BFBFBF;
    }

    .orange_css {
        color: #FFFFFF;
        background-color: #EB6100;
    }

    .red_css {
        color: #FFFFFF;
        background-color: #E60012;
    }

    .blue_css {
        color: #FFFFFF;
        background-color: #21A0FF;
    }

    .aaa_css {
        color: #FFFFFF;
        background-color: #E968A1;
    }

    .bbb_css {
        color: #FFFFFF;
        background-color: #FED600;
    }

    .ccc_css {
        color: #FFFFFF;
        background-color: #FF5E5A;
    }

    .ddd_css {
        color: #FFFFFF;
        background-color: #843900;
    }

    .eee_css {
        color: #FFFFFF;
        background-color: #181D4B;
    }

    .fff_css {
        color: #FFFFFF;
        background-color: #007D65;
    }

    .ggg_css {
        color: #FFFFFF;
        background-color: #1D953F;
    }

    .hhh_css {
        color: #FFFFFF;
        background-color: #CA8687;
    }

    .iii_css {
        color: #FFFFFF;
        background-color: #596032;
    }

    .jjj_css {
        color: #FFFFFF;
        background-color: #F36C21;
    }
    .fl_flex{
        display: flex;
        width: 100%;
        justify-content: space-between;
    }
    .quick_left{
        width: 650px;

    }
    .quick_right{
        width: 505px;
    }
    .white_bg{
        background-color: white;
        padding: 10px;
        margin-top: 10px;
        border-radius: 5px;
    }

    .clientTag {
        display: flex;align-items: center; flex-wrap: wrap;
    }
</style>
